<template>
  <div class="card-form">
    <page-main
      ref="main"
      :loading="loading"
      :table-data="table"
      :tablePage="page"
      @submit="reload"
      ><page-header
        @formLoad="formLoad"
        @reset="reset"
        @submit="handleSubmit"
        slot="header"
        ref="header"/>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
    /></page-main>
  </div>
</template>
<script>
export default {
  name: 'master-fabricStockOut',
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main')
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0
      }
    }
  },
  methods: {
    formLoad(type) {
      if (type === 'add') {
        this.$refs.main.formLoad(type, 'add')
      }
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0
      }
    },
    reload() {
      this.$refs.header.query()
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    //加载数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .fabricStockOutListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
